export default __webpack_public_path__ + "static/media/step3@3x.46b37123.jpg";